export const actionTypes = {
  SET_SELECTED_TYPE: "SET_SELECTED_TYPE",
  SET_IS_COLUMN_VISIBLE: "SET_IS_COLUMN_VISIBLE",
  SET_COLUMN_ORDER: "SET_COLUMN_ORDER",

  GET_TABLES_CONFIGURATION_MANAGEMENT_DATA:
    "GET_TABLES_CONFIGURATION_MANAGEMENT_DATA",
  GET_TABLES_CONFIGURATION_MANAGEMENT_DATA_SUCCESS:
    "GET_TABLES_CONFIGURATION_MANAGEMENT_DATA_SUCCESS",
  GET_TABLES_CONFIGURATION_MANAGEMENT_DATA_FAILURE:
    "GET_TABLES_CONFIGURATION_MANAGEMENT_DATA_FAILURE",

  UPDATE_TABLES_CONFIGURATION: "UPDATE_TABLES_CONFIGURATION",
  UPDATE_TABLES_CONFIGURATION_SUCCESS: "UPDATE_TABLES_CONFIGURATION_SUCCESS",
  UPDATE_TABLES_CONFIGURATION_FAILURE: "UPDATE_TABLES_CONFIGURATION_FAILURE",
};

export const setSelectedTypeAction = (payload: string) => ({
  type: actionTypes.SET_SELECTED_TYPE,
  payload,
});

export const getTablesConfigurationManagementDataAction = (payload: any) => ({
  type: actionTypes.GET_TABLES_CONFIGURATION_MANAGEMENT_DATA,
  payload,
});
export const getTablesConfigurationManagementDataSuccessAction = (
  payload: any
) => ({
  type: actionTypes.GET_TABLES_CONFIGURATION_MANAGEMENT_DATA_SUCCESS,
  payload,
});
export const getTablesConfigurationManagementDataFailureAction = (
  error: any
) => ({
  type: actionTypes.GET_TABLES_CONFIGURATION_MANAGEMENT_DATA_FAILURE,
  error,
});

export const updateTablesConfigurationAction = (payload: any) => ({
  type: actionTypes.UPDATE_TABLES_CONFIGURATION,
  payload,
});
export const updateTablesConfigurationSuccessAction = (payload: any) => ({
  type: actionTypes.UPDATE_TABLES_CONFIGURATION_SUCCESS,
  payload,
});
export const updateTablesConfigurationFailureAction = (error: any) => ({
  type: actionTypes.UPDATE_TABLES_CONFIGURATION_FAILURE,
  error,
});

export const setIsColumnVisibleAction = (payload: {
  isVisible: boolean;
  columnName: string;
  tableKey: string;
}) => ({
  type: actionTypes.SET_IS_COLUMN_VISIBLE,
  payload,
});

export const setColumnOrderAction = (payload: {
  newOrder: number;
  columnName: string;
  tableKey: string;
}) => ({
  type: actionTypes.SET_COLUMN_ORDER,
  payload,
});
